import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitRegistrySystemKeyboard } from './TraitRegistrySystemKeyboard';
import { TraitRegistrySystemInner } from './inner/TraitRegistrySystemInner';
export class TraitRegistrySystem extends TraitRegistryCategory {
    label = 'System';
    c_keyboard = new TraitRegistrySystemKeyboard(this);
    c_inner = new TraitRegistrySystemInner(this);
}
